<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-06-03 15:39:07
 * @FilePath: \gcp-fe\src\app\noticesList\components\baseBreadCrumb.vue
 * @Description: 
-->
<template>
  <div class="ccui-home-navigation" ref="noPrintTop">
    <!-- 面包屑 -->
    <el-breadcrumb
      class="ccui-home-navigation-crumbs-container"
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item :to="{ path: '/' }" v-if="isShowPortal"
        >首页</el-breadcrumb-item
      >
      <el-breadcrumb-item
        v-for="(item, index) in currBreadCrumb"
        :to="{
          path: item.path
        }"
        :key="index"
      >
        <span
          class="ccui-home-curr-crumb"
          v-if="index === currBreadCrumb.length - 1"
          @click="item.clickFn ? item.clickFn() : null"
          :title="item.title"
          :style="{ cursor: item.clickFn ? 'pointer' : 'default' }"
          >{{ item.title }}</span
        >
        <span
          v-else
          @click="item.clickFn ? item.clickFn() : null"
          style="cursor: pointer;"
          >{{ item.title }}</span
        >
        <!-- <span
          v-else
          @click="item.clickFn ? item.clickFn() : null"
          :style="{ cursor: item.clickFn ? 'pointer' : 'default' }"
          >{{ item.title }}</span
        > -->
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: "baseBreadCrumb",
  props: {
    currBreadCrumb: {
      type: Array,
      default() {
        return [];
      }
    },
    isShowPortal: {
      //面包屑是否显示 首页（加这个是为了，搜索页面面包屑不显示 首页）
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped lang="scss"></style>
